import { addressGuidePoints } from "@/mocks/homeData";

export default function AddressGuide() {
  return (
    <section id="address" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-6">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-700 uppercase tracking-wider">
              <i className="ri-link-unlink"></i>
              Broken Address
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              地址失效：为什么会失效，又该怎么判断
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              「地址失效」是这类站点打不开时出现频率很高的一个原因。理解它是怎么发生的，
              你就能更快判断手上这个地址到底还能不能用，而不是一直原地刷新。
            </p>

            <div className="mt-7 space-y-3">
              {addressGuidePoints.map((p, i) => (
                <div
                  key={p.title}
                  className="rounded-lg bg-background-50 border border-background-200/80 p-5 flex gap-4"
                >
                  <span className="w-8 h-8 rounded-md bg-accent-100 text-accent-800 flex items-center justify-center text-sm font-heading font-bold shrink-0">
                    {i + 1}
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">{p.title}</h3>
                    <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6 lg:sticky lg:top-24">
            <div className="rounded-lg overflow-hidden border border-background-200/80 bg-background-50">
              <div className="w-full h-56 md:h-72 bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimal%20illustration%20of%20a%20broken%20chain%20link%20beside%20an%20internet%20address%20bar%20on%20a%20warm%20cream%20background%2C%20muted%20clay%20and%20amber%20tones%2C%20flat%20editorial%20style%2C%20clean%20geometric%20shapes%2C%20no%20text&width=1200&height=900&seq=address-broken-01&orientation=landscape"
                  alt="抽象示意：断开的链接与地址栏，表现地址失效的概念"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 md:p-6">
                <p className="font-heading text-base font-semibold text-foreground-950">识别新地址时的三个原则</p>
                <ul className="mt-4 space-y-3 text-sm text-foreground-600">
                  {[
                    "核对域名拼写，注意容易混淆的相似字符与后缀。",
                    "不轻信要求下载程序、输入账号或付款的页面。",
                    "以长期稳定、可核实的来源为准，而非来历不明的转发。",
                  ].map((t) => (
                    <li key={t} className="flex items-start gap-3">
                      <span className="mt-0.5 w-5 h-5 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center text-xs shrink-0">
                        <i className="ri-check-line"></i>
                      </span>
                      <span className="leading-relaxed">{t}</span>
                    </li>
                  ))}
                </ul>
                <p className="mt-5 text-xs text-foreground-500 leading-relaxed">
                  说明：本段内容为一般性的识别与安全建议，不构成对任何具体地址的推荐。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}